import isEmpty from "lodash/isEmpty";
import MPENetworks from "singularitynet-platform-contracts/networks/MultiPartyEscrow";

import { fetchAuthenticatedUser } from "./userActions/loginActions";
import { APIEndpoints, APIPaths } from "../../AWS/APIEndpoints";
import { getAPI, postAPI, putAPI, patchAPI, initializeAPIOptions } from "../../../Utils/API";
import { APIError } from "shared/dist/utils/API";
import { aiServiceListActions, loaderActions } from "./";
import { LoaderContent } from "../../../Utils/Loader";
import { getAddress, initSDK } from "shared/dist/utils/snetSdk";
import { blockChainEvents } from "../../../Utils/Blockchain";
import { defaultGroups } from "../reducers/aiServiceDetailsReducer";
import { serviceCreationStatus } from "../../../Pages/AiServiceCreation/constant";
import ValidationError from "shared/dist/utils/validationError";
import RegistryContract from "../../../Utils/PlatformContracts/RegistryContract";
import { MetamaskError } from "shared/dist/utils/error";
import * as Sentry from "@sentry/browser";
import { storageProviders } from "../../../Utils/storageTypes";
import { protoStatusTypes } from "../../../Pages/AiServiceCreation/PricingDistribution/SelfHostedFields/ServiceSetup/UploadProto/ProtoFilesStatus";
import {
    searchDeployments as searchDeploymentsAPI,
    checkGitRepository as checkGitRepositoryAPI,
    initiateDeployment,
} from "../../../Components/HaaS/api";
import { updatePrimaryServiceGroup } from "../../../Utils/serviceGroups";
import { selectHaasState } from "../selectors/aiServiceDetailsSelector";
import { isHostingAvailable } from "../../../Components/HaaS/Components/HostingUnavailable";

export const SET_ALL_SERVICE_DETAILS_ATTRIBUTES = "SET_ALL_SERVICE_DETAILS_ATTRIBUTES";
export const SET_AI_SERVICE_ID = "SET_AI_SERVICE_ID";
export const SET_AI_SERVICE_ID_AVAILABILITY = "SET_AI_SERVICE_ID_AVAILABILITY";
export const SET_AI_SERVICE_NAME = "SET_AI_SERVICE_NAME";
export const SET_AI_SERVICE_UUID = "SET_AI_SERVICE_UUID";
export const SET_AI_SERVICE_TOUCHED_FLAG = "SET_AI_SERVICE_TOUCHED_FLAG";
export const SET_AI_SERVICE_GROUPS = "SET_AI_SERVICE_GROUPS";
export const SET_IS_HAAS_USED = "SET_IS_HAAS_USED";
export const SET_AI_SERVICE_TYPE = "SET_AI_SERVICE_TYPE";
export const SET_AI_SERVICE_FREE_CALL_SIGNER_ADDRESS = "SET_AI_SERVICE_FREE_CALL_SIGNER_ADDRESS";
export const SET_AI_SERVICE_DETAIL_LEAF = "SET_AI_SERVICE_DETAIL_LEAF";
export const SET_AI_SERVICE_MULTIPLE_DETAILS = "SET_AI_SERVICE_MULTIPLE_DETAILS";
export const SET_SERVICE_PROVIDER_COMMENT = "SET_SERVICE_PROVIDER_COMMENT";
export const SET_AI_SERVICE_STATE_STATE = "SET_AI_SERVICE_STATE_STATE";
export const SET_SERVICE_DETAILS_PROTO_URL = "SET_SERVICE_DETAILS_PROTO_URL";
export const SET_SERVICE_HERO_IMAGE_URL = "SET_SERVICE_HERO_IMAGE_URL";
export const SET_SERVICE_DEMO_FILES_URL = "SET_SERVICE_DEMO_FILES_URL";
export const SET_SERVICE_DETAILS_FOUND_IN_BLOCKCHAIN = "SET_SERVICE_DETAILS_FOUND_IN_BLOCKCHAIN";
export const SET_PROGRESS_STATUS = "SET_PROGRESS_STATUS";
export const SET_BUILD_STATUS = "SET_BUILD_STATUS";
export const SET_CREATE_NEW_AI_SERVICE = "SET_CREATE_NEW_AI_SERVICE";
export const SET_DEMO_COMPONENT_AVAILABLE = "SET_DEMO_COMPONENT_AVAILABLE";
export const SET_SAVED_PRICING_DETAILS = "SET_SAVED_PRICING_DETAILS";
export const SET_AI_SERVICE_DEPLOYMENTS = "SET_AI_SERVICE_DEPLOYMENTS";
export const SET_HAAS_AFFECTED_SERVICE_DETAILS = "SET_HAAS_AFFECTED_SERVICE_DETAILS";

export const setAllAttributes = (value) => ({
    type: SET_ALL_SERVICE_DETAILS_ATTRIBUTES,
    payload: value,
});

export const setCreateNewAiService = (createNewAIService) => ({
    type: SET_CREATE_NEW_AI_SERVICE,
    payload: createNewAIService,
});

export const setDemoComponentAvailable = (demoComponentAvailable) => ({
    type: SET_DEMO_COMPONENT_AVAILABLE,
    payload: demoComponentAvailable,
});

export const setServiceTouchedFlag = (touchFlag) => ({
    type: SET_AI_SERVICE_TOUCHED_FLAG,
    payload: touchFlag,
});

export const setServiceId = (serviceId) => ({
    type: SET_AI_SERVICE_ID,
    payload: serviceId,
});

export const setIdServiceAvailability = (serviceAvailability) => ({
    type: SET_AI_SERVICE_ID_AVAILABILITY,
    payload: serviceAvailability,
});

export const setServiceName = (serviceName) => ({
    type: SET_AI_SERVICE_NAME,
    payload: serviceName,
});

export const setServiceUuid = (serviceUuid) => ({
    type: SET_AI_SERVICE_UUID,
    payload: serviceUuid,
});

export const setAiServiceDetailLeaf = (name, value) => ({
    type: SET_AI_SERVICE_DETAIL_LEAF,
    payload: { name, value },
});

export const setAiServiceGroups = (groups) => ({ type: SET_AI_SERVICE_GROUPS, payload: groups });

export const setIsHaasUsed = (isHaaSUsed) => ({ type: SET_IS_HAAS_USED, payload: isHaaSUsed });

export const setAiServiceType = (type) => ({ type: SET_AI_SERVICE_TYPE, payload: type });

export const setAiServiceMultipleDetails = (entries) => ({
    type: SET_AI_SERVICE_MULTIPLE_DETAILS,
    payload: entries,
});

export const setServiceProviderComment = (comment) => ({
    type: SET_SERVICE_PROVIDER_COMMENT,
    payload: comment,
});

export const setAiServiceStateState = (state) => ({
    type: SET_AI_SERVICE_STATE_STATE,
    payload: state,
});

export const setServiceDetailsProtoUrl = (url) => ({
    type: SET_SERVICE_DETAILS_PROTO_URL,
    payload: url,
});

export const setServiceHeroImageUrl = (url) => ({ type: SET_SERVICE_HERO_IMAGE_URL, payload: url });

export const setServiceDemoFilesUrl = (url) => ({ type: SET_SERVICE_DEMO_FILES_URL, payload: url });

export const setServiceDetailsFoundInBlockchain = (found) => ({
    type: SET_SERVICE_DETAILS_FOUND_IN_BLOCKCHAIN,
    payload: found,
});

export const setSavedPricingDetails = (bool) => ({
    type: SET_SAVED_PRICING_DETAILS,
    payload: bool,
});
export const setDeployments = (deployments) => ({
    type: SET_AI_SERVICE_DEPLOYMENTS,
    payload: deployments,
});

/**
 * @param {Object} details
 * @param {} details.
 */
const setHaasAffectedServiceDetails = (details) => ({
    type: SET_HAAS_AFFECTED_SERVICE_DETAILS,
    payload: details,
});

const createServiceAPI = (orgUuid, serviceName) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.REGISTRY.name;
    const apiPath = APIPaths.AI_CREATE_SERVICE(orgUuid);
    const body = { display_name: serviceName };
    const apiOptions = initializeAPIOptions(token, body);
    return await postAPI(apiName, apiPath, apiOptions);
};

export const createService = (orgUuid, serviceName) => async (dispatch) => {
    try {
        dispatch(loaderActions.startAppLoader(LoaderContent.CREATE_SERVICE));
        const { data, error } = await dispatch(createServiceAPI(orgUuid, serviceName));
        if (error.code) {
            throw new APIError(error.message);
        }
        dispatch(setServiceName(serviceName));
        dispatch(setServiceUuid(data.service_uuid));
        return data;
    } catch (error) {
        throw error;
    } finally {
        dispatch(loaderActions.stopAppLoader());
    }
};

const createLaunchAiService =
    (orgUuid, serviceUuid, storageProvider, lighthouseToken) => async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.REGISTRY.name;
        const apiPath = APIPaths.LAUNCH_AI_SERVICE(orgUuid, serviceUuid, storageProvider);
        const body = { lighthouse_token: lighthouseToken };
        const apiOptions = initializeAPIOptions(token, body);
        return await postAPI(apiName, apiPath, apiOptions);
    };

export const launchAiService =
    (orgUuid, serviceUuid, storageProvider, lighthouseToken) => async (dispatch) => {
        try {
            dispatch(loaderActions.startAppLoader(LoaderContent.PUBLISH_SERVICE_TO_IPFS));
            const { data, error } = await dispatch(
                createLaunchAiService(orgUuid, serviceUuid, storageProvider, lighthouseToken)
            );
            if (error.code) {
                throw new APIError(error.message);
            }
            dispatch(setServiceTouchedFlag(false));
            dispatch(loaderActions.stopAppLoader());
            return data;
        } catch (error) {
            dispatch(loaderActions.stopAppLoader());
            throw error;
        }
    };

const validateServiceIdAPI = (orgUuid, serviceId) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.REGISTRY.name;
    const apiPath = APIPaths.AI_SERVICE_ID_VALIDATE(orgUuid, serviceId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};

export const validateServiceId = (orgUuid, serviceId) => async (dispatch) => {
    try {
        dispatch(loaderActions.startValidateServiceIdLoader());
        const { data, error } = await dispatch(validateServiceIdAPI(orgUuid, serviceId));
        if (error.code) {
            throw new APIError(error.message);
        }
        dispatch(loaderActions.stopValidateServiceIdLoader());
        return data;
    } catch (error) {
        dispatch(loaderActions.stopValidateServiceIdLoader());
        throw error;
    }
};

const generatePricingpayload = (pricing) =>
    pricing.map((price) => ({
        default: price.default,
        price_model: price.priceModel,
        price_in_cogs: Number(price.priceInCogs),
    }));

export const generateGroupsPayload = (groups) =>
    groups
        .map((group) => {
            if (!group.id) {
                return undefined;
            }
            return {
                group_name: group.name,
                group_id: group.id,
                free_calls: Number(group.freeCallsAllowed),
                free_call_signer_address: group.freeCallSignerAddress,
                pricing: generatePricingpayload(group.pricing),
                endpoints: group.endpoints,
                test_endpoints: group.testEndpoints,
                daemon_addresses: group.daemonAddresses,
            };
        })
        .filter((el) => el !== undefined);

// TODO remove orgId. MPS has to figure out orgId from orgUuid
const generateSaveServicePayload = (serviceDetails) => {
    const parseContributors = () => {
        return serviceDetails.contributors
            .split(",")
            .map((el) => el.trim())
            .filter((el, index, data) => data.indexOf(el) === index && !isEmpty(el))
            .map((c) => ({ name: c, email_id: "" }));
    };

    const payloadForSubmit = {
        service_id: serviceDetails.newId ? serviceDetails.newId : serviceDetails.id,
        display_name: serviceDetails.name,
        storage_provider: serviceDetails.storageProvider,
        short_description: serviceDetails.shortDescription,
        description: serviceDetails.longDescription,
        project_url: serviceDetails.projectURL,
        proto: {},
        service_type: serviceDetails.serviceType,
        assets: {
            proto_files: {
                url: serviceDetails.assets.protoFiles.url,
                hash: serviceDetails.assets.protoFiles.hash,
            },
            hero_image: {
                url: serviceDetails.assets.heroImage.url,
                hash: serviceDetails.assets.heroImage.hash,
            },
            demo_files: {
                required: serviceDetails.demoComponentAvailable ? 1 : 0,
                url: serviceDetails.assets.demoFiles.url,
                hash: serviceDetails.assets.demoFiles.hash,
            },
        },
        contributors: parseContributors(),
        groups: generateGroupsPayload(serviceDetails.groups),
        tags: serviceDetails.tags,
        price: serviceDetails.price,
        priceModel: serviceDetails.priceModel,
        comments: {
            SERVICE_PROVIDER: serviceDetails.comments.SERVICE_PROVIDER,
            SERVICE_APPROVER: serviceDetails.comments.SERVICE_APPROVER,
        },
        mpe_address:
            MPENetworks[process.env.REACT_APP_ETH_NETWORK][process.env.REACT_APP_TOKEN_NAME][
                process.env.REACT_APP_STAND
            ].address,
    };

    return payloadForSubmit;
};

const saveServiceDetailsAPI = (orgUuid, serviceUuid, serviceDetailsPayload) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.REGISTRY.name;
    const apiPath = APIPaths.SAVE_AI_SERVICE(orgUuid, serviceUuid);
    const body = serviceDetailsPayload;
    const apiOptions = initializeAPIOptions(token, body);
    return await putAPI(apiName, apiPath, apiOptions);
};

export const saveServiceDetails =
    (orgUuid, serviceDetails, silent = false) =>
    async (dispatch) => {
        try {
            dispatch(setAllAttributes(serviceDetails));
            if (serviceDetails.serviceState.state === serviceCreationStatus.REJECTED) {
                throw new ValidationError(
                    "Hi your service is rejected for any change/approval. Please contact support to proceed"
                );
            }
            !silent && dispatch(loaderActions.startAppLoader(LoaderContent.SAVE_SERVICE_DETAILS));
            const serviceDetailsPayload = generateSaveServicePayload(serviceDetails);
            if (serviceDetails.savedPricingDetails && isEmpty(serviceDetails.groups[0].endpoints)) {
                Sentry.captureMessage(
                    `Save API: payload endpoints are empty after saving price details. 
        Payload JSON: ${JSON.stringify(serviceDetailsPayload)}`
                );
                Sentry.captureException(
                    new Error("Save API: payload endpoints are empty after saving price details.")
                );
            }
            const { error } = await dispatch(
                saveServiceDetailsAPI(orgUuid, serviceDetails.uuid, serviceDetailsPayload)
            );
            if (error.code) {
                dispatch(loaderActions.stopAppLoader());
                throw new APIError(error.message);
            }
            dispatch(setAiServiceStateState(serviceCreationStatus.DRAFT));
            dispatch(loaderActions.stopAppLoader());
        } catch (error) {
            if (serviceDetails.savedPricingDetails) {
                Sentry.captureMessage(`Save API: error after saving pricing details. 
      ServiceDetails: ${JSON.stringify(serviceDetails)}.
      Error: ${error.toString()}`);
                Sentry.captureException(error);
            }
            dispatch(loaderActions.stopAppLoader());
            throw error;
        }
    };

const patchServiceDetailsAPI =
    (orgUuid, serviceUuid, serviceDetailsPayload) => async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.REGISTRY.name;
        const apiPath = APIPaths.SAVE_AI_SERVICE(orgUuid, serviceUuid);
        const body = serviceDetailsPayload;
        const apiOptions = initializeAPIOptions(token, body);
        return await patchAPI(apiName, apiPath, apiOptions);
    };

export const patchServiceDetails =
    (orgUuid, serviceUuid, patchDetailsPayload) => async (dispatch) => {
        const { error } = await dispatch(
            patchServiceDetailsAPI(orgUuid, serviceUuid, patchDetailsPayload)
        );
        if (error.code) {
            throw new APIError(error.message);
        }
    };

const getServiceDetailsAPI = (orgUuid, serviceUuid) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.REGISTRY.name;
    const apiPath = APIPaths.FETCH_AI_SERVICE(orgUuid, serviceUuid);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};

export const getHandlingFileStatus = (orgUuid, serviceUuid, fileType) => async (dispatch) => {
    try {
        const { data, error } = await dispatch(getServiceDetailsAPI(orgUuid, serviceUuid));
        if (error.code) {
            throw new APIError(error.message);
        }
        if (!data.media[fileType]) {
            return protoStatusTypes.NOT_FIND;
        }
        return data.media[fileType]?.status.toLowerCase();
    } catch (error) {
        throw error;
    }
};

export const getHandlingFileBuildId = (orgUuid, serviceUuid, fileType) => async (dispatch) => {
    try {
        const { data, error } = await dispatch(getServiceDetailsAPI(orgUuid, serviceUuid));
        if (error.code) {
            throw new APIError(error.message);
        }
        if (!data.media[fileType]) {
            return null;
        }

        return data.media[fileType]?.build_id;
    } catch (error) {
        throw error;
    }
};

export const getServiceDetails = (orgUuid, serviceUuid, orgId) => async (dispatch) => {
    try {
        const { data, error } = await dispatch(getServiceDetailsAPI(orgUuid, serviceUuid));
        const serviceDetailsFromBlockchain = await getServiceDetailsFromBlockchain(
            orgId,
            data.service_id
        );
        dispatch(setServiceDetailsFoundInBlockchain(serviceDetailsFromBlockchain?.found ?? false));
        if (error.code) {
            throw new APIError(error.message);
        }
        const service = parseServiceDetails(data, serviceUuid);
        const demoComponentAvailable = data.media.demo_files?.required ?? true;
        dispatch(setDemoComponentAvailable(demoComponentAvailable));
        dispatch(setAllAttributes(service));
        return service;
    } catch (error) {
        throw error;
    }
};

const getDeploymentInfo = (orgId, serviceId) => async (dispatch) => {
    if (!isHostingAvailable()) return;
    const deploymentsResult = await dispatch(searchDeploymentsAPI(orgId, serviceId));

    if (deploymentsResult.error.code) {
        throw new APIError(deploymentsResult.error.message);
    }
    dispatch(setDeploymentAndOverlayServiceDetails(deploymentsResult.data));
};

export const getServiceDetailsWithHaas = (orgUuid, serviceUuid, orgId) => async (dispatch) => {
    const { data, error } = await dispatch(getServiceDetailsAPI(orgUuid, serviceUuid));
    const [serviceDetailsFromBlockchain] = await Promise.all([
        getServiceDetailsFromBlockchain(orgId, data.service_id),
        dispatch(getDeploymentInfo(orgId, data.service_id)),
    ]);
    dispatch(setServiceDetailsFoundInBlockchain(serviceDetailsFromBlockchain?.found ?? false));
    if (error.code) {
        throw new APIError(error.message);
    }

    const service = parseServiceDetails(data, serviceUuid);
    const demoComponentAvailable = data.media.demo_files?.required ?? true;
    dispatch(setDemoComponentAvailable(demoComponentAvailable));
    dispatch(setAllAttributes(service));

    return service;
};

const setDeploymentAndOverlayServiceDetails = (payload) => (dispatch, getState) => {
    dispatch(setDeployments(payload));

    const state = getState();
    const serviceGroups = state.aiServiceDetails.groups;
    const orgGroups = state.organization.groups;

    const { hasDaemon, hasService } = selectHaasState(state);
    if (hasDaemon) {
        const patch = {};
        if (payload.daemon.daemonEndpoint) {
            patch.endpoints = {
                [payload.daemon.daemonEndpoint]: { valid: true },
            };
        }
        patch.freeCallSignerAddress = process.env.REACT_APP_HAAS_FREECALL_ADDRESS;
        if (Object.keys(patch).length) {
            const updatedGroups = updatePrimaryServiceGroup({
                serviceGroups,
                orgGroups,
                patch,
            });
            dispatch(setAiServiceGroups(updatedGroups));
        }
    }

    if (hasService) {
        dispatch(
            setHaasAffectedServiceDetails({
                serviceType: process.env.REACT_APP_HAAS_SERVICE_TYPE,
            })
        );
    }
};

/**
 * @param {Object} param0
 * @param {string} param0.orgId
 * @param {string} param0.serviceId
 * @param {boolean} param0.onlyDaemon
 * @param {string | undefined} param0.serviceEndpoint //only for Daemon tab
 * @param {Array<{key: string, value: string, location: string}> | undefined} param0.serviceCredentials //only for Daemon tab
 * @param {string | undefined} param0.githubAccountName //only for DaemonAI tab
 * @param {string | undefined} param0.githubRepositoryName //only for DaemonAI tab
 */
const initiateDeploymentAndUpdateDatails = (payload) => async (dispatch) => {
    const { data } = await dispatch(initiateDeployment(payload));
    dispatch(setDeploymentAndOverlayServiceDetails(data));
};

/**
 * @param {Object} payload
 * @param {string} payload.orgId
 * @param {string} payload.serviceId
 * @param {string} payload.serviceEndpoint
 * @param {Array<{key: string, value: string, location: string}> | undefined} payload.serviceCredentials
 */
export const initiateDaemon = (payload) => async (dispatch) => {
    try {
        dispatch(loaderActions.startAppLoader(LoaderContent.INITIATE_DAEMON));
        await dispatch(initiateDeploymentAndUpdateDatails({ ...payload, onlyDaemon: true }));
    } finally {
        dispatch(loaderActions.stopAppLoader());
    }
};
/**
 * @param {Object} payload
 * @param {string} payload.accountName
 * @param {string} payload.repositoryName
 */
export const checkGitRepository = (payload) => async (dispatch) => {
    try {
        dispatch(loaderActions.startAppLoader(LoaderContent.CHECK_GIT_REPOSITORY));
        return await dispatch(checkGitRepositoryAPI(payload));
    } finally {
        dispatch(loaderActions.stopAppLoader());
    }
};
/**
 * @param {Object} payload
 * @param {string} payload.orgId
 * @param {string} payload.serviceId
 * @param {string} payload.githubAccountName
 * @param {string} payload.githubRepositoryName
 */
export const initiateDaemonAI = (payload) => async (dispatch) => {
    try {
        dispatch(loaderActions.startAppLoader(LoaderContent.INITIATE_DAEMON_AI));
        await dispatch(initiateDeploymentAndUpdateDatails({ ...payload, onlyDaemon: false }));
    } finally {
        dispatch(loaderActions.stopAppLoader());
    }
};

const parseServiceDetails = (data, serviceUuid) => {
    const parsePricing = (pricing) =>
        pricing.map((price) => ({
            default: price.default,
            priceModel: price.price_model,
            priceInCogs: price.price_in_cogs,
        }));
    const parseGroups = (groups) => {
        const retrieveTestEndpointFromGroup = (group) => {
            if (!isEmpty(group.test_endpoints)) {
                return group.test_endpoints;
            }
            if (!isEmpty(group.endpoints)) {
                const endpoints = Object.keys(group.endpoints);
                return [endpoints[0]];
            }
            return [];
        };

        if (isEmpty(groups)) {
            return defaultGroups;
        }
        return groups.map((group) => ({
            name: group.group_name,
            id: group.group_id,
            pricing: parsePricing(group.pricing),
            endpoints: group.endpoints || [],
            daemonAddresses: group.daemon_addresses || [],
            testEndpoints: retrieveTestEndpointFromGroup(group),
            freeCallsAllowed: group.free_calls,
            freeCallSignerAddress: group.free_call_signer_address,
        }));
    };
    // TODO: Certain elements are hard coded need to update after all forms integration
    const service = {
        serviceState: {
            state: data.service_state.state,
        },
        uuid: serviceUuid,
        name: data.display_name,
        id: data.service_id,
        newId: data.service_id,
        shortDescription: data.short_description,
        longDescription: data.description,
        storageProvider: Boolean(data.storage_provider)
            ? data.storage_provider
            : storageProviders.IPFS,
        projectURL: data.project_url,
        proto: {
            hash: "",
            encoding: "",
            type: "",
        },
        assets: {
            heroImage: data.media.hero_image
                ? {
                      url: data.media.hero_image.url,
                      hash: "",
                  }
                : {},
            demoFiles: data.media.demo_files
                ? {
                      url: data.media.demo_files.url,
                      status: data.media.demo_files?.status?.toLowerCase(),
                      buildId: data.media.demo_files.build_id,
                      required: data.media.demo_files?.required ?? true,
                  }
                : {},
            protoFiles: data.media.proto_files
                ? {
                      url: data.media.proto_files.url,
                      status: data.media.proto_files?.status?.toLowerCase(),
                      hash: data.media.proto_files.hash,
                  }
                : {},
        },
        serviceType: data.service_type,
        contributors: data.contributors.map((c) => c.name).join(","),
        hash: data.metadata_hash,
        groups: parseGroups(data.groups),
        tags: data.tags,
        freecallsAllowed: data.freecalls_allowed,
        freeCallSignerAddress: isEmpty(data.groups) ? "" : data.groups[0].free_call_signer_address,
        comments: {
            SERVICE_APPROVER: data.comments.SERVICE_APPROVER ? data.comments.SERVICE_APPROVER : "",
            SERVICE_PROVIDER: data.comments.SERVICE_PROVIDER ? data.comments.SERVICE_PROVIDER : "",
        },
    };

    return service;
};

const submitServiceDetailsForReviewAPI =
    (orgUuid, serviceUuid, serviceDetailsPayload) => async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.REGISTRY.name;
        const apiPath = APIPaths.SUBMIT_AI_SERVICE(orgUuid, serviceUuid);
        const body = serviceDetailsPayload;
        const apiOptions = initializeAPIOptions(token, body);
        return await putAPI(apiName, apiPath, apiOptions);
    };

export const submitServiceDetailsForReview =
    (orgUuid, serviceUuid, serviceDetails) => async (dispatch) => {
        try {
            if (serviceDetails.serviceState.state === serviceCreationStatus.REJECTED) {
                throw new ValidationError(
                    "Hi your service is rejected for any change/approval. Please contact support to proceed"
                );
            }
            dispatch(loaderActions.startAppLoader(LoaderContent.SUBMIT_SERVICE_FOR_REVIEW));
            // TODO remove orgId. MPS has to figure out orgId from orgUuid
            const serviceDetailsPayload = generateSaveServicePayload(serviceDetails);
            const { error } = await dispatch(
                submitServiceDetailsForReviewAPI(orgUuid, serviceUuid, serviceDetailsPayload)
            );
            if (error.code) {
                throw new APIError(error.message);
            }
            dispatch(setAiServiceStateState(serviceCreationStatus.APPROVAL_PENDING));
            dispatch(loaderActions.stopAppLoader());
        } catch (error) {
            dispatch(loaderActions.stopAppLoader());
            throw error;
        }
    };

const saveTransactionAPI = (orgUuid, serviceUuid, hash, publisherAddress) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.REGISTRY.name;
    const apiPath = APIPaths.SAVE_SERVICE_TRANSACTION(orgUuid, serviceUuid);
    const body = { transaction_hash: hash, wallet_address: publisherAddress };
    const apiOptions = initializeAPIOptions(token, body);
    return await postAPI(apiName, apiPath, apiOptions);
};

const saveTransaction = (orgUuid, serviceUuid, hash, ownerAddress) => async (dispatch) => {
    try {
        dispatch(loaderActions.startAppLoader(LoaderContent.SAVE_SERVICE_TRANSACTION));
        const { error } = await dispatch(
            saveTransactionAPI(orgUuid, serviceUuid, hash, ownerAddress)
        );
        if (error.code) {
            throw new APIError(error.message);
        }
    } catch (error) {
        dispatch(loaderActions.stopAppLoader());
        throw error;
    }
};

const registerInBlockchain =
    (organization, serviceDetails, serviceMetadataURI) => async (dispatch) => {
        const orgId = organization.id;
        const serviceId = serviceDetails.id;
        const sdk = await initSDK();
        const address = await getAddress(sdk);

        dispatch(loaderActions.startAppLoader(LoaderContent.METAMASK_TRANSACTION));

        const method = sdk._registryContract
            .createServiceRegistration(orgId, serviceId, serviceMetadataURI)
            .send({ from: address })
            .on(blockChainEvents.TRANSACTION_HASH, async (hash) => {
                await dispatch(
                    saveTransaction(organization.uuid, serviceDetails.uuid, hash, address)
                );
                dispatch(loaderActions.startAppLoader(LoaderContent.PUBLISH_SERVICE_TO_BLOCKCHAIN));
            })
            // eslint-disable-next-line no-unused-vars
            .once(blockChainEvents.CONFIRMATION, async ({ confirmationNumber, receipt }) => {
                if (!receipt.status) {
                    method.off();
                    throw new Error(receipt);
                }
                await dispatch(
                    aiServiceListActions.setRecentlyPublishedService(serviceDetails.name)
                );
                await dispatch(setServiceDetailsFoundInBlockchain(true));
                dispatch(loaderActions.stopAppLoader());
                await method.off();
            })
            .on(blockChainEvents.ERROR, (error) => {
                dispatch(loaderActions.stopAppLoader());
                new Error(error);
            });
        return method;
    };

const uploadFileAPI = (assetType, fileBlob, orgUuid, serviceUuid) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const url = `${APIEndpoints.UTILITY.endpoint}${APIPaths.UPLOAD_FILE}?type=${assetType}&org_uuid=${orgUuid}&service_uuid=${serviceUuid}`;
    const res = await fetch(url, {
        method: "POST",
        headers: { authorization: token },
        body: fileBlob,
    });
    return await res.json();
};

export const uploadFile = (assetType, fileBlob, orgUuid, serviceUuid) => async (dispatch) => {
    try {
        const { data, error } = await dispatch(
            uploadFileAPI(assetType, fileBlob, orgUuid, serviceUuid)
        );
        if (error.code) {
            throw new APIError(error.message);
        }
        return data;
    } catch (error) {
        dispatch(loaderActions.stopAppLoader());
        throw error;
    }
};

const updateInBlockchain =
    (organization, serviceDetails, serviceMetadataURI) => async (dispatch) => {
        const sdk = await initSDK();
        const address = await getAddress(sdk);
        const method = sdk._registryContract
            .updateServiceRegistration(organization.id, serviceDetails.id, serviceMetadataURI)
            .send({ from: address })
            .on(blockChainEvents.TRANSACTION_HASH, async (hash) => {
                await dispatch(
                    saveTransaction(organization.uuid, serviceDetails.uuid, hash, address)
                );
                dispatch(loaderActions.startAppLoader(LoaderContent.PUBLISH_SERVICE_TO_BLOCKCHAIN));
            })
            // eslint-disable-next-line no-unused-vars
            .once(blockChainEvents.CONFIRMATION, async ({ confirmationNumber, receipt }) => {
                if (!receipt.status) {
                    method.off();
                    throw new Error(receipt);
                }
                await dispatch(
                    aiServiceListActions.setRecentlyPublishedService(serviceDetails.name)
                );
                dispatch(loaderActions.stopAppLoader());
                await method.off();
                return confirmationNumber;
            })
            .on(blockChainEvents.ERROR, (error) => {
                dispatch(loaderActions.stopAppLoader());
                throw new MetamaskError(error.message);
            });
        return method;
    };

const getServiceDetailsFromBlockchain = async (orgId, serviceId) => {
    try {
        const registry = new RegistryContract();
        return await registry.getServiceRegistrationById(orgId, serviceId).call();
    } catch (error) {
        // eslint-disable-next-line
        console.error(error);
        return { found: false };
    }
};

export const publishService =
    (organization, serviceDetails, serviceMetadataURI) => async (dispatch) => {
        try {
            const serviceDetailsFromBlockchain = await getServiceDetailsFromBlockchain(
                organization.id,
                serviceDetails.id
            );
            if (!serviceDetailsFromBlockchain.found) {
                const registerInBlockchainResponse = await dispatch(
                    registerInBlockchain(organization, serviceDetails, serviceMetadataURI)
                );
                return registerInBlockchainResponse;
            }
            dispatch(setServiceTouchedFlag(false));
            return await dispatch(
                updateInBlockchain(organization, serviceDetails, serviceMetadataURI)
            );
        } catch (error) {
            dispatch(loaderActions.stopAppLoader());
            throw error;
        }
    };

const getSampleDaemonConfigAPI =
    (orgUuid, serviceUuid, testDaemon = false) =>
    async (dispatch) => {
        const daemonConfigNetwork = { TEST: "TEST", MAIN: "MAIN" };
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.REGISTRY.name;
        const apiPath = APIPaths.SAMPLE_DAEMON_CONFIG(orgUuid, serviceUuid);
        const queryParams = testDaemon
            ? { network: daemonConfigNetwork.TEST }
            : { network_id: process.env.REACT_APP_ETH_NETWORK, network: daemonConfigNetwork.MAIN };
        const apiOptions = initializeAPIOptions(token, undefined, queryParams);
        return await getAPI(apiName, apiPath, apiOptions);
    };

export const getSampleDaemonConfig =
    (orgUuid, serviceUuid, testDaemon = false) =>
    async (dispatch) => {
        try {
            dispatch(loaderActions.startAppLoader(LoaderContent.SAMPLE_DAEMON_CONFIG));
            const { data, error } = await dispatch(
                getSampleDaemonConfigAPI(orgUuid, serviceUuid, testDaemon)
            );
            if (error.code) {
                dispatch(loaderActions.stopAppLoader());
                throw new APIError(error.message);
            }
            dispatch(loaderActions.stopAppLoader());
            return data;
        } catch (e) {
            dispatch(loaderActions.stopAppLoader());
            throw e;
        }
    };

export const updateBuildStatus = (section, status, progressStatuses) => {
    const updatedStatus = progressStatuses.map((progress) => {
        if (progress.section === section) {
            return { ...progress, status };
        }

        return progress;
    });

    return { type: SET_BUILD_STATUS, payload: updatedStatus };
};

export const updateProgressStatus = (section, status, progressStatuses) => {
    const updatedStatuses = progressStatuses.map((progress) => {
        if (progress.section === section) {
            return { ...progress, status };
        }

        return progress;
    });

    return { type: SET_PROGRESS_STATUS, payload: updatedStatuses };
};
